import React, { useState } from "react";
import { RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { idb } from "@/lib/offlineDb";
import { countOps } from "@/lib/offlineQueue";

// Clears cached app files + offline read data (keeps unsynced offline changes), then reloads.
export async function refreshApp(onStart) {
  const pending = await countOps();
  const msg = pending
    ? `Zwischenspeicher und Offline-Daten werden gelöscht und neu geladen. ${pending} noch nicht übertragene Offline-Änderung(en) bleiben erhalten. Fortfahren?`
    : "Zwischenspeicher und Offline-Daten dieser Seite werden gelöscht und die App neu geladen. Fortfahren?";
  if (!window.confirm(msg)) return;
  onStart?.();
  try { await idb.clear("cache"); } catch (_) {}
  try { if (window.caches) { for (const k of await caches.keys()) await caches.delete(k); } } catch (_) {}
  try { if (navigator.serviceWorker) { for (const r of await navigator.serviceWorker.getRegistrations()) await r.unregister(); } } catch (_) {}
  window.location.replace(`${window.location.pathname}?r=${Date.now()}`);
}

export default function RefreshAppButton() {
  const [busy, setBusy] = useState(false);
  const run = () => refreshApp(() => setBusy(true));
  return (
    <Button type="button" variant="outline" className="w-full mt-3" onClick={run} disabled={busy} data-testid="login-refresh-app-btn">
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <RefreshCw className="h-4 w-4 mr-2" />}Aktualisieren
    </Button>
  );
}
